import React, { useState, useEffect } from 'react';
import { Box, Typography, TextField, Button, List, ListItem, ListItemText, Paper, Table, TableHead, TableBody, TableRow, TableCell, TableContainer } from '@mui/material';
import axios from 'axios';

const DeviceManagement = () => {
  const [devices, setDevices] = useState([]);
  const [newDevice, setNewDevice] = useState({ name: '', ip: '', mac: '' });
  const [error, setError] = useState('');

  useEffect(() => {
    fetchDevices();
  }, []);

  const fetchDevices = async () => {
    try {
      const res = await axios.get('/devices');
      setDevices(Array.isArray(res.data) ? res.data : []);
    } catch {
      setDevices([]);
    }
  };

  const handleChange = (e) => {
    setNewDevice({ ...newDevice, [e.target.name]: e.target.value });
    setError('');
  };

  const handleAdd = async () => {
    if (!newDevice.name || !newDevice.ip || !newDevice.mac) return;
    // IP kontrolü (trim ve case-insensitive)
    const newIp = newDevice.ip.trim().toLowerCase();
    if (devices.some((d) => (d.ip || '').trim().toLowerCase() === newIp)) {
      setError('Bu IP adresine sahip bir cihaz zaten mevcut!');
      return;
    }
    try {
      await axios.post('/devices', newDevice);
      fetchDevices();
      setNewDevice({ name: '', ip: '', mac: '' });
      setError('');
    } catch (err) {
      if (err.response && err.response.status === 409) {
        setError('Bu IP adresine sahip bir cihaz zaten mevcut!');
      } else {
        setError('Cihaz eklenirken bir hata oluştu.');
      }
    }
  };

  return (
    <Box sx={{ maxWidth: 400, mx: 'auto', mt: 4 }}>
      <Typography variant="h4" gutterBottom>Cihaz Yönetimi</Typography>
      <Paper sx={{ p: 2, mb: 2 }}>
        <Typography variant="h6">Yeni Cihaz Ekle</Typography>
        <TextField label="Cihaz Adı" name="name" value={newDevice.name} onChange={handleChange} fullWidth sx={{ mb: 1 }} />
        <TextField label="IP Adresi" name="ip" value={newDevice.ip} onChange={handleChange} fullWidth sx={{ mb: 1 }} />
        <TextField label="MAC Adresi" name="mac" value={newDevice.mac} onChange={handleChange} fullWidth sx={{ mb: 1 }} />
        {error && <Typography color="error" sx={{ mb: 1 }}>{error}</Typography>}
        <Button variant="contained" onClick={handleAdd}>Ekle</Button>
      </Paper>
      <Typography variant="h6">Kayıtlı Cihazlar</Typography>
      <TableContainer component={Paper} sx={{ mt: 2 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Cihaz Adı</TableCell>
              <TableCell>IP Adresi</TableCell>
              <TableCell>MAC Adresi</TableCell>
              <TableCell>Durum</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {devices.map((d) => (
              <TableRow key={d.id}>
                <TableCell>{d.id}</TableCell>
                <TableCell>{d.name}</TableCell>
                <TableCell>{d.ip}</TableCell>
                <TableCell>{d.mac}</TableCell>
                <TableCell>{d.status === 'active' ? 'Aktif' : d.status === 'passive' ? 'Pasif' : d.status}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default DeviceManagement;
